import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-cream/40 py-6 text-center text-xs" data-id="element-84">
      <p data-id="element-85">
        © Super Combo Carpintería Plegable PRO 2026 — Todos los derechos
        reservados.
      </p>
    </footer>;
}